import { useCallback } from 'react'

import { useGlobalState } from '@/hooks/useGlobalState'
import type { SetupProgress } from '@/services/api/api.types'

/**
 * Hook that provides manual setup progress completion
 * All setup steps are now completed manually through user actions
 */
export function useSetupProgressTracker() {
  const { authenticationStore } = useGlobalState()
  const { isSponsorAdmin, isInSetup, setupProgress } = authenticationStore

  /**
   * Manually mark a specific setup step as complete
   */
  const markStepComplete = useCallback(
    async (stepKey: keyof SetupProgress) => {
      if (!isSponsorAdmin || !isInSetup) return

      // Skip if this step is already completed
      if (setupProgress[stepKey] === true) {
        return
      }

      const completion = { [stepKey]: true }

      try {
        const result = await authenticationStore.updateSetupProgress(completion)
        if (!result.ok) {
          console.error('Failed to mark step complete:', result.message)
        }
      } catch (error) {
        console.error('Failed to mark step complete:', error)
      }
    },
    [authenticationStore, isSponsorAdmin, isInSetup, setupProgress],
  )

  return {
    markStepComplete,
  }
}
